export const DESTINATION_CITY = "Select Destination City";
export const DESTINATION_BRANCH = "Select Destination Branch";
export const MANUAL_LR = 'Please Enter Manual LR'
export const SENDER_MOBILE = "Enter Valid Sender Mobile number";
export const SENDER_NAME = "Enter Valid Sender Name";
export const SENDER_PHONE = "Please enter Valid Phone no"
export const SENDER_PARTY = "Select Sender Party";
export const SENDER_ADDRESS = "Enter Address";
export const SENDER_GST = "Enter Valid GST Number";
export const EWAY_BILL = "Enter Valid E-Way Bill No";
export const EWAY_BILL_DUPLICATE = "This E-Way No. Already Added, Please Add Another E-Way No.";
export const ID_PROOF = "Select Any Valid  Id Proof";
export const ID_NUMBER = "Enter Valid Id Number";
export const UPLOAD_FILE = "Upload File size upto 25kb";
export const BILL_NUMBER = "Enter Valid Bill Number";
export const BILL_AMOUNT = "Enter Bill Amount";
export const RECEIVER_MOBILE = "Enter Valid Receiver Mobile number";
export const RECEIVER_NAME = "Enter Valid Receiver Name";
export const RECEIVER_PARTY = "Select Receiver Party";
export const RECEIVER_ADDRESS = "Enter Address";
export const RECEIVER_GST = "Enter Valid GST Number";
export const CONSIGNMENT_TYPE = "Select Consignment Type";
export const PACK_EMTHOD = "Select Pack Method";
export const UNITS = "Enter Units";
export const GOOGS_VALUE = "Enter Goods Value";
export const WEIGHT_ACTUAL = "Enter Weight Actual";
export const WEIGHT_CHARGED = "Enter Weight Charge";
export const RATE  = "Enter Rate";
export const FREIGHT = "Freight Can not be Zero";
export const COLLECTION_CARTAGE = "Enter Colleection Cartage";
export const DELIVERY_CARTAGE = "Enter Drop Cartage";
export const HAMALI = "Enter Hamali";
export const OPERATOR_HAMALI = "Enter Operator Hamali";
export const Valuation = "Enter Valuation";
export const DOCUMENT_CHARGE = "Enter Document Charge";
export const PICKUP_CHARGE = "Enter Pickup Charge";
export const DROPOFF_CHARGE = "Enteer Drop Off Charge";
export const CONSIGNMENT_DATA = "Enter Consignment Data";

// delivery errors
export const RECIPIENT_NAME ="Fill Recipient Name"
export const RECIPIENT_CONTACT ="Fill Recipient Contact No"
export const RECIPIENT_CONTACT_LENGTH ="Fill Valid Recipient Contact No"
export const DELIVERY_REMARKS ="Fill Delivery Remarks"
export const CANCEL_REMARKS = "Fill Cancel Remarks"
export const REC_ID_PROOF="Fill ID Card Number "

// All Error of Trabsfer Reason 
export const TRANSFER_TO_BRANCH ="Select Transfer To Branch"
export const TRANSFER_REASON ="Fill Transfer Reason"
export const TRANSFER_BY_VEHICLE ="Select Transfer By Vehicle"
export const SELECT_LR ="Please Select LR"
export const ENTER_CHALLAN_NUMBER ="Enter Challan Number"


//All Error Branch Receive
export const SELECT_RECEIVE_TO_Branch ="Select Received To Branch"

//Receive Dashboard
export const SELECT_RECEIVE_DASH_Branch ="Select Branch Wise"
//All Error dispatch 

export const VEHICLE_NO="Select Vehicle To Dispatch"
export const VEHICLE_NO_FORMAT = `Enter valid vehicle No TN-46-AM-1234 OR TN-46-M-1234`
export const SELECT_CROSSING_CITY = "select Crossing City"
export const SELECT_CROSSING_BRANCH = "select Crossing City Branch"
export const NO_TRIPS_IN_SELECTED = `No Passenger Trip Has been Found, Please Select Another Vehicle!`
export const CONFIGURE_MASTER_BUS_NUMBER = `Configure MasterBus Number`
